import React,{useState,useEffect} from "react";
import './Stopwatch.css'

const Stopwatch = () => {
  const [time, setTime] = useState(0);
  const [timerOn, setTimerOn] = useState(false);

  useEffect(() => {
    let interval = null;
      if (timerOn) {
        interval = setInterval(() => {
        setTime((prevTime) => prevTime + 10);
        }, 10);
       } else if (!timerOn) {
       clearInterval(interval);
      }
    return () => clearInterval(interval);
  }, [timerOn]);

  return (
    <div className="appp" >
    <div className="Timers">
      <h2>Stopwatch</h2>
      <div id="display">
        <span>{("0" + Math.floor((time / 60000) % 60)).slice(-2)}:</span>
        <span>{("0" + Math.floor((time / 1000) % 60)).slice(-2)}:</span>
        <span>{("0" + ((time / 10) % 100)).slice(-2)}</span>
      </div>

      <div id="buttons">
        {!timerOn && time === 0 && (
          <button className="btnn" onClick={() => setTimerOn(true)}>Start</button>
        )}


        {timerOn && <button className="btnn"  onClick={() => setTimerOn(false)}>Stop</button>}


        {!timerOn && time > 0 && (
          <button className="btnn" onClick={() => setTime(0)}>Reset</button>
        )}


        {!timerOn && time > 0 && (
          <button className="btnn" onClick={() => setTimerOn(true)}>Resume</button>
        )}
      </div>
    </div>
    </div>
  );
};

export default Stopwatch;